import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

const attachCredits = () => axios.post(`${API_URLS.CART}apply-credits`, {});

export default attachCredits;
